
<template>
<div class='homepage_left' :class="{'closeBtn':pageshow}">
  <div class="topDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>全县面雨量</span>
      </div>
      <div class="more">
        <el-radio-group v-model="rainTime" size="mini">
          <el-radio-button v-for="(item,index) in radioList" :key="index" :label="item.label"  @click.native="timeChange($event,item.label)">{{item.name}}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="chartMain" v-loading="loading1">
      <div id="barchart"></div>
    </div>
  </div>
  <div class="bomDiv">
    <div class="titleDiv flexDiv flexSB">
      <div class="title flexDiv">
        <div class="title_logo flexDiv"><img src="@/assets/homepage_img_ptcopy/title_logo.gif"></div>
        <span>雨量信息</span>
      </div>
      <div class="more">
        <!-- 乡镇检索 -->
         <div class="townSearch">
          <el-input @change="getStatisticsRain" size="small" placeholder="请输入终端名称" v-model="staname" clearable>
            <i @click="getStatisticsRain" slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="chartMain" ref="bomTable" v-loading="loading3">
      <el-table ref="rainTable" :data="tableData"  style="width: 100%" :max-height="tableHeight" highlight-current-row @row-click="changeSt" >
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <el-table-column prop="stnm" label="终端名称" align="center" style="cursor:hand" sortable>
          <template slot-scope="scope" >
            <el-tooltip effect="light" :content="scope.row.stcd" placement="top" class="item" popper-class="hiddenOverflow">
              <span style="cursor:pointer">{{scope.row.stnm}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="addvnm" label="乡镇" align="center" sortable></el-table-column>
        <el-table-column prop="accRain" label="雨量" align="center" sortable :sort-method="sortMethodAccRain"></el-table-column>
      </el-table>
    </div>
  </div>
  <div class="showBtn flexC"  @click="showpage"><i class="el-icon-caret-left" :class="{'tran180':pageshow}"></i></div>
  <el-dialog title="时间选择" :visible.sync="timeChoose" :append-to-body="true" :modal="false" width="40%" :close-on-click-modal="false">
    <div class="dialog_wrapper">
      <div class="dialog_wrapper_top">
        <span class="top_inner_left">降雨时段</span>
        <span class="top_inner_right">
          <el-radio-group v-model="onTheHourRainTime" size="mini">
            <el-radio-button v-for="(item,index) in radioList2" :key="index" :label="item.label" @click.native="customTimeChange($event,item.label)">{{item.name}}</el-radio-button>
          </el-radio-group>
        </span>
      </div>
      <div class="dialog_wrapper_bottom">
        <span class="bottom_inner_left">起止时间</span>
        <span class="bottom_inner_right">
          <el-date-picker
            v-model="BeginTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            :picker-options="Global.pickerOptionsStart(EndTime)"
            placeholder="开始时间">
          </el-date-picker>
          <span style="color:#194F83;margin:0 5px 0 5px">——</span>
          <el-date-picker
            v-model="EndTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm"
            format="yyyy-MM-dd HH:mm"
            :picker-options="Global.pickerOptionsEnd(BeginTime)"
            placeholder="结束时间">
          </el-date-picker>
        </span>
      </div>
      <div style="width:100%;text-align:center;margin-top:30px;">
        <span slot="footer" class="dialog-footer">
          <el-button @click="timeChoose = false">取 消</el-button>
          <el-button type="primary" @click="timeselect">确 定</el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</div>
</template>

<script>
import api from '@/api/homepage_ptcopy'
import meiyuTypes from '@/store/types/meiyu'
import eventbus from '@/utils/eventbus'
export default {
  components: {},
  data () {
    return {
      staname: '',
      dzmactive: false,
      timeChoose: false,
      loading1: false,
      loading2: false,
      loading3: false,
      rainData: [],
      radioList: [
        { name: '降雨等值面', label: '降雨等值面' },
        { name: '实时', label: '实时' },
        { name: '1h', label: '1' },
        { name: '3h', label: '3' },
        { name: '24h', label: '24' },
        { name: '自定义', label: '自定义' }
      ],
      onTheHourRainTime: '1', // 自定义整点时间的选中
      radioList2: [
        { name: '1小时', label: '1' },
        { name: '3小时', label: '3' },
        { name: '24小时', label: '24' },
        { name: '48小时', label: '48' },
        { name: '72小时', label: '72' }
      ],
      tableData: [],
      BeginTime: '',
      EndTime: '',
      stid: '', // 当前测站编码
      stnm: '', // 当前测站
      rainTime: '1',
      tableHeight: 380,
      overflowWarningRain: {},
      timer: null,
      pageshow: false,
      perRowHeight: '',
      imageLayerdraw: false,
      nowchoose: '',
      aDDVCD: 330324
    }
  },
  computed: {},
  watch: {},
  methods: {
    sortMethodAccRain(a, b) {
      let bsort = (b.accRain === undefined || b.accRain === null) ? -1 : b.accRain
      let asort = (a.accRain === undefined || a.accRain === null) ? -1 : a.accRain
      return asort - bsort
    },
    timeselect () {
      if (this.nowchoose === '降雨等值面') {
        this.getRianGraph()
      }
      this.timeChoose = false
      this.getStatisticsRain()
      this.getRain_divide_by_addvcd()
      this.getRain_divide_by_addvcd(1)
    },
    jydzm () {
      // if (this.imageLayerdraw) {
      // this.timeChoose = false
      // let timearr = [this.BeginTime, this.EndTime]
      // eventbus.$emit('theraintime', timearr) // $emit这个方法会触发一个事件
      // this.dzmactive = false
      // this.dzmactive = true
      // } else {
      //   this.timeChoose = true
      //   this.dzmactive = true
      // }
      this.timeChoose = true
      this.dzmactive = true
    },
    // 降雨等值面
    getRianGraph () {
      let timearr = [this.BeginTime, this.EndTime]
      // console.log(123, timearr)
      // this.$emit('theraintime', timearr)
      eventbus.$emit('theraintime', timearr) // $emit这个方法会触发一个事件
    },
    showpage () {
      this.pageshow = !this.pageshow
      this.$emit('rePosition', this.pageshow)
    },
    setRow (id) {
      this.tableData.forEach((item, index) => {
        if (item.id === id) {
          this.$refs.rainTable.setCurrentRow(item)
          this.$nextTick(() => {
            document.querySelector('.el-table__body-wrapper').scrollTo(0, this.perRowHeight * index)
          })
        }
      })
    },
    changeSt (data, column, event) {
      this.$emit('showPoint', data)
      if (column.label === '站名') {
        this.$emit('showDialog', data)
      }
    },
    timeChange (e, label) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理
      eventbus.$emit('typeselect', label) // $emit这个方法会触发一个事件
      if (label === '自定义') {
        this.timeChoose = true
        this.$emit('closeDialog', true)
      } else if (label === '降雨等值面') {
        this.jydzm()
      } else if (label === '实时') {
        let date = new Date()
        this.EndTime = this.getCurrentTime(-1)
        this.BeginTime = this.EndTime.split(' ')[0] + ' ' + date.getHours() + ':00'
        this.getStatisticsRain()
        this.getRain_divide_by_addvcd()
        this.hour = '1'
      } else {
        this.dzmactive = false
        this.BeginTime = this.getCurrentTime(label)
        this.EndTime = this.getCurrentTime(0)
        this.getStatisticsRain()
        this.getRain_divide_by_addvcd()
      }
      this.nowchoose = label
    },
    // 实时降雨自定义内的时间切换
    customTimeChange (e, label) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理
      this.hour2 = label
      this.BeginTime = this.getCurrentTime(label)
      this.EndTime = this.getCurrentTime(0)
      // console.log(777, this.BeginTime)
      this.getStatisticsRain()
      this.getRain_divide_by_addvcd()
      this.getRain_divide_by_addvcd(1)
      this.timeChoose = false
      if (this.nowchoose === '降雨等值面') {
        this.getRianGraph()
      }
    },
    // 获取实时降雨
    getRain_divide_by_addvcd () {
      // console.log('全县降雨量1111111')
      // this.loading1 = true
      // api.getAnalyticalRain(this.BeginTime, this.EndTime).then(res => {
      //   console.log(res, '全县降雨量22222')
      //   this.loading1 = false
      //   let data = res.data.TownRain
      //   data.unshift({ Name: '全县', Value: res.data.AvgRain })
      //   this.rainData = data
      //   this.drawBarchart()
      // })
      this.loading1 = true
      this.$store.dispatch(meiyuTypes.GET_ANALYTICAL_RAIN, {
        sID: this.$store.state.sid,
        beginTime: this.BeginTime,
        endTime: this.EndTime,
        addvcd: this.aDDVCD
        // type: this.type,
        // stationCount: this.stationCount,
        // townCount: this.townCount,
        // partCount: this.partCount,
        // cACD: this.cACD
      }).then(res => {
        this.loading1 = false
        let data = res.townRain
        // 全县面雨量由大到小排序
        const handleSort = (prop) => {
          return function(a, b) {
            const val1 = a[prop]
            const val2 = b[prop]
            return val2 - val1
          }
        }
        data = data.sort(handleSort('value')) // 排序后全县面雨量
        data.unshift({ name: '全县', value: res.avgRain })
        this.rainData = data
        this.drawBarchart()
      })
    },
    // 各个测站雨量
    getStatisticsRain () {
      this.loading3 = true
      api.getStatisticsRain({
        SID: this.$store.state.sid,
        StationName: this.staname,
        BeginTime: this.BeginTime,
        EndTime: this.EndTime
      }).then(res => {
        this.loading3 = false
        let data = res.data.rows
        let sortlist = data.sort((a, b) => {
          let bsort = (b.accRain === undefined || b.accRain === null) ? -1 : b.accRain
          let asort = (a.accRain === undefined || a.accRain === null) ? -1 : a.accRain
          return bsort - asort
        })
        this.tableData = sortlist
        this.$emit('getRain', this.tableData)
        this.$nextTick(() => {
          let temp = document.getElementsByClassName('el-table__row')
          this.perRowHeight = temp[0].offsetHeight
        })
      })
    },
    drawBarchart () {
      let xData = []
      let seriesData = []
      let maxRain = 1
      this.rainData.forEach(item => {
        let reg1 = new RegExp('镇', 'g')// g代表全部
        let reg2 = new RegExp('街道', 'g')// g代表全部
        let reg3 = new RegExp('岛管委会', 'g')// g代表全部
        if (item.name) {
          let Name = item.name.replace(reg1, '').replace(reg2, '').replace(reg3, '')
          if (maxRain < item.value) {
            maxRain = item.value
          }
          // Name = Name.replace('区', '县')
          xData.push(Name)
          seriesData.push(item.value)
        }
      })
      if (maxRain > 10) {
        maxRain = maxRain + 5
      } else {
        maxRain = 10
      }
      let myChart = this.$echarts.init(document.getElementById('barchart'))
      myChart.clear()
      myChart.setOption({
        grid: {
          left: '0%',
          right: '0%',
          top: '5%',
          bottom: '0%',
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        xAxis: {
          type: 'category',
          data: xData,
          axisLabel: {
            interval: 0,
            rotate: 0,
            textStyle: {
              color: '#fff'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            textStyle: {
              color: '#fff'
            }
          },
          splitLine: {
            show: false
          },
          max: Math.ceil(maxRain) // 最大值
        },
        dataZoom: [{
          type: 'slider',
          show: true,
          xAxisIndex: [0],
          zoomLock: true, // 只能平移，不能缩放
          moveOnMouseMove: true, // 鼠标移动触发平移
          moveOnMouseWheel: true, // 滚轮触发平移
          rangeMode: ['value'],
          startValue: 0,
          endValue: 9,
          fillerColor: 'rgba(255, 255, 255, 0.4)',
          height: 6,
          bottom: 0,
          borderColor: 'rgba(0, 0, 0, 0)',
          showDetail: false
        }],
        series: [{
          data: seriesData,
          type: 'bar',
          barWidth: '50%',
          itemStyle: {
            color: '#3C6EFB'
          },
          label: {
            show: true,
            position: 'top', // 在上方显示
            formatter: '{c}',
            textStyle: {
              color: '#fff'
            }
          }
        }]
      })
    },
    getCurrentTime (hour) {
      let nowdate = new Date()
      let hours = hour === -1 ? 0 : hour
      nowdate.setTime(nowdate.getTime() - 60 * 60 * 1000 * Number(hours))
      let year = nowdate.getFullYear()
      let mon = nowdate.getMonth() + 1
      let dd = nowdate.getDate()
      let hh = nowdate.getHours()
      let mm = nowdate.getMinutes()
      let time =
        year +
        '-' +
        (mon > 9 ? mon : '0' + mon) +
        '-' +
        (dd > 9 ? dd : '0' + dd) +
        ' ' +
        (hh > 9 ? hh : '0' + hh) +
        ':' +
        (hour === -1 ? (mm > 9 ? mm : '0' + mm) : '00')
      return time
    }
  },
  created () { },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.EndTime = this.getCurrentTime(0)
    this.BeginTime = this.getCurrentTime(1)
    this.getRain_divide_by_addvcd()
    this.getStatisticsRain()
    this.$nextTick(() => {
      let bomTable = this.$refs.bomTable
      this.tableHeight = bomTable.offsetHeight
    })
    let _this = this
    this.timer = setInterval(() => {
      if (_this.rainTime !== '自定义' && _this.rainTime !== '降雨等值面') {
        _this.EndTime = _this.getCurrentTime(0)
        _this.BeginTime = _this.getCurrentTime(_this.rainTime)
      }
      _this.getRain_divide_by_addvcd()
      _this.getStatisticsRain()
    }, 1000 * 60 * 5)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang='less' scoped>
*{
  box-sizing: border-box;
}
.homepage_left{
  position: absolute;
  top: 80px;
  left: 20px;
  z-index: 500;
  width: 520px;
  height: calc(100% - 85px);
  color: #fff;
  // background-image: linear-gradient(269deg, rgba(0,23,84,0.00) 0%, rgba(0,36,116,0.85) 100%);
  background-color: #1e346a;
  transition: all 1s ease;
}
.topDiv{
  width: 100%;
  height: 300px;
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
    padding: 5px 5px 0;
    background: rgba(0,0,0,0.2);
    .infotext{
      color: #fff;
      font-size: 16px;
      line-height: 20px;
      padding-left: 20px;
    }
    #barchart{
      width: 100%;
      height: calc(100% - 25px);
    }
  }
}
.bomDiv{
  width: 100%;
  height: calc(100% - 300px);
  .chartMain{
    width: 100%;
    height: calc(100% - 50px);
  }
  /deep/ .el-table{
    background: none!important;
  }
  /deep/.el-table__empty-text{
    color: #fff;
  }
  /deep/ .el-table th{
    color: #fff;
    padding: 10px 0;
    background: #3C6EFB;
    border-right: 1px solid #101e3e;
    border-bottom: 1px solid #101e3e;
  }
  /deep/ .el-table__body tr.current-row>td{
    background-color: #69A8EA !important;
    color: #fff;
  }
  /deep/ .el-table td{
    color: #fff;
    padding: 9px 0;
    background: #172c5d;
    border-right: 1px solid #101e3e;
    border-bottom: 1px solid #101e3e;
  }
  /deep/ .el-table--border{
    border: 1px solid #101e3e;
  }
  /deep/ .el-table--border::after,.el-table::before{
    background: none;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover>td{
    background: #0a37a0;
  }
}
.titleDiv{
  height: 48px;
  line-height: 48px;
  padding-left: 30px;
  padding-right: 10px;
  border-top: 1px solid;
  border-bottom: 1px solid;
  border-image: linear-gradient(to right, rgba(60,110,251,1) , rgba(60,110,251,0)) 10;
  .title{
    font-size: 22px;
    height: 50px;
    align-items: center;
  }
  .more{
    font-size: 16px;
    cursor: pointer;
    /deep/ .el-radio-button__inner{
      color:#fff!important;
      background: rgba(0,0,0,0);
      padding-left: 10px;
      padding-right: 10px;
      border: none;
      border-radius: 0;
      font-size: 14px;
    }
    /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
      background: #1f6fef;
    }
  }
  .title_logo{
    height: 50px;
    margin-right: 10px;
    img{
      height: 20px;
    }
  }
  .icon{
    display: flex;
    height: 50px;
    align-items: center;
    margin-right: 10px;
    transform: skew(-31deg);
    div{
      &:nth-of-type(1){
        width: 15px;
        height: 18px;
        background: #3C6EFB;
      }
      &:nth-of-type(2){
        width: 10px;
        height: 18px;
        background: #F7E700;
      }
    }
  }
}
.showBtn{
  width: 30px;
  height: 45px;
  position: absolute;
  font-size: 16px;
  color: #fff;
  background: rgba(22,48,128,0.2);
  right: -30px;
  top: 50px;
  border: 1px solid #0878b4;
  box-shadow: 0 0 5px #0878b4;
  cursor: pointer;
  i{
    transform: rotate(0deg);
    transition: all 1s ease;
  }
  .tran180{
    transform: rotate(180deg);
  }
}
.closeBtn {
  left: -520px;
}
/deep/ .el-loading-mask{
  background: rgba(0,0,0,0.6);
}
/deep/ .el-dialog{
  background-color: rgba(17,32,71,0.6);
  .el-dialog__title{
    color: #fff;
  }
  .el-dialog__headerbtn .el-dialog__close{
    color: #fff;
  }
}
.flexDiv {
    /* 横向排列 */
    display: flex;
    align-items: center;
}

.flexC {
  display: flex;
  align-items: center;
  justify-content: center;
}

.flexDivCol {
  /* 垂直居中 */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.flexFS {
  /* 左对齐 */
  justify-content: flex-start;
}

.flexFE {
  /* 右对齐 */
  justify-content: flex-end;
}

.flexSA {
  /* 每个项目两侧的间隔相等 */
  justify-content: space-around;
}

.flexSB {
  /* 两端对齐 */
  justify-content: space-between;
}
.dialog_wrapper {
  width: 100%;
  .dialog_wrapper_top {
    width: 100%;
    .top_inner_left {
      width: 25%;
      height: 60px;
      line-height: 60px;
      padding: 10px 10px 10px 10px;
      margin-left: 20px;
      color: #9FABB9;
    }
    .top_inner_right {
      height: 60px;
      line-height: 60px;
      padding: 10px 0 10px 0;
      /deep/ .el-radio-button__inner {
        margin-left: 32px;
        background-color: #183C62;
        border: 1px solid #183C62;
        color: #9FB2C6;
        width: 70px;
        height: 32px;
        line-height: 15px;
      }
      /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner {
        box-shadow: 0 0 0 0 #183C62;
        background-color: #009FFF;
        color: #fff;
      }
    }
  }
  .dialog_wrapper_bottom {
    width: 100%;
    .bottom_inner_left {
      width: 20%;
      height: 60px;
      line-height: 60px;
      padding: 10px 10px 10px 10px;
      margin-left: 20px;
      color: #9FABB9;
    }
    .bottom_inner_right {
      height: 60px;
      line-height: 60px;
      padding: 10px 10px 10px 10px;
      margin-left: 20px;
    }
  }
  /deep/ .el-button--default {
    background-color: #184D7C;
    border: 1px solid #184D7C;
    color: #9FB2C6;
  }
}
  /deep/::-webkit-scrollbar{
  width: 0px;
  height: 7px;
  background-color: #072351;
}
// 测站查询框样式
.townSearch .el-input {
  display: inline-block;
  position: relative;
  top: 0rem;
  // right: 0.2rem;
  width: 180px;
}
.townSearch /deep/ .el-input__inner {
  background-color: transparent;
  border: 0.03125rem solid #079eb6;
  color: #ddd;
}
.townSearch /deep/ .el-input__inner:hover {
  border-color: #079eb6;
}
</style>
